import type { PayloadReparto } from "./api";
import { formatNumero, hoyISO } from "./format";
import { montoAInput, parseMonto } from "./gastos";

/** "25.00" → "25 %"; "-10.50" → "-10,5 %"; null → "—" (sin aportes no hay rentabilidad). */
export function formatRentabilidad(pct: string | null): string {
  return pct === null ? "—" : `${formatNumero(pct)} %`;
}

/** "12.5000" → "12,5 %". */
export function formatPorcentajeA(pct: string): string {
  return `${formatNumero(pct)} %`;
}

export interface FormReparto {
  fecha: string;
  monto_usd: string;
  nota: string;
  /** id de la caja como texto; "" = la principal (no se manda). */
  caja_id: string;
}

export type ErroresReparto = Partial<Record<keyof FormReparto, string>>;

/** Prellenado con todo lo disponible de ventas (si es positivo) y la fecha de hoy. */
export function formReparto(disponibleUsd: string, hoy = hoyISO(), cajaDefecto = ""): FormReparto {
  const hayPlata = Number(disponibleUsd) > 0;
  return { fecha: hoy, monto_usd: hayPlata ? montoAInput(disponibleUsd) : "", nota: "", caja_id: cajaDefecto };
}

export function validarReparto(f: FormReparto): ErroresReparto {
  const e: ErroresReparto = {};
  if (!f.fecha) e.fecha = "Elegí la fecha";
  if (parseMonto(f.monto_usd) === null) e.monto_usd = "Ingresá un monto mayor a cero";
  if (f.nota.trim().length > 200) e.nota = "Hasta 200 caracteres";
  return e;
}

export function aPayloadReparto(f: FormReparto): PayloadReparto {
  return {
    fecha: f.fecha, monto_usd: parseMonto(f.monto_usd) ?? "0", nota: f.nota.trim() || null,
    ...(f.caja_id ? { caja_id: Number(f.caja_id) } : {}),
  };
}
